import { PropTypes } from 'prop-types'
import React, { Component } from 'react'
import { utils } from '../utils';
import { Fade, Zoom } from "react-awesome-reveal";
import { connect } from 'react-redux';
import { Action_removeFromCart } from '../store/action/action-cart'
import { Action_createOrder, Action_order_clear } from '../store/action/action-order'
import { Action_LoginsOpener } from '../store/action/Action-ALL'
import Modal from 'react-modal';
// import Google_login from './auth/Google-login';
import { Button, Paper, IconButton } from '@material-ui/core';
import LoadingHook from './hooks/LoadingHook';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import CloseIcon from '@material-ui/icons/Close';
import ModalErrorHook from './hooks/ModalErrorHook';
//import history from './hooks/history';
// import dateFormat from 'dateformat';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

class Cart extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isShowCheckout: false,
            cartEmail: '',
            cartName: '',
            cartAddress: '',
        }
    }

    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    // FORM SUBMIT
    createOrder = (e) => {
        e.preventDefault();

        const totalPrice = this.props.cartItems.reduce((ttl, i) => { return ttl + i.price * i.count }, 0)

        this.props.Action_createOrder({
            name: this.state.cartName || this.props.user.name,
            email: this.state.cartEmail || this.props.user.email,
            address: this.state.cartAddress,
            orderItems: this.props.cartItems,
            totalPrice: totalPrice
        })


    }

    cartTotal = () => {
        const { cartItems } = this.props;
        let sum = 0;

        if (cartItems) {
            cartItems.forEach((i) => (
                sum += i.price * i.count
            ))
        }

        return utils.formateCurrency(sum);
    }

    closeModal = () => {
        // console.log('enter closeModal:')
        this.props.Action_order_clear()
        this.props.history.push('/MsgScreen/Thank You.')
    }

    scrollToBottom = () => {

        if (this.props.user?.isAuthenticated) {
            //console.log('-------this.props.user?.isAuthenticated:', this.props.user?.isAuthenticated)
            //this.crtBox_Ref.scrollIntoView({ behavior: "smooth" });
            // document.getElementsByClassName('cartBox')[0].scrollIntoView({ behavior: "smooth" });
            document.getElementsByClassName('cartBox')[0].scrollTop =
                document.getElementsByClassName('form-container')[0]?.clientHeight || 520
        }
    }

    componentDidMount() {
        this.scrollToBottom();
    }

    componentDidUpdate() {
        this.scrollToBottom();
    }


    render() {

        // const crtBox_Ref = React.createRef()
        const { cartItems, order, loading, error, user } = this.props;

        const baseImgUrl = utils.constants.S3_imgBaseURL;

        return (

            <span className='cartBox'>  {/* ref={(el) => { this.crtBox_Ref = el; }}> */}
                <Paper>
                    {/* ----------------------- ERROR */}
                    {error && <ModalErrorHook msg={error} title='OOps.!' />}

                    {/* ----------------------- LOADING */}
                    {loading && <LoadingHook />}

                    {
                        <div className="cart cart-header">
                            {(cartItems?.length || 0) === 0 ? 'Cart is empty' : (cartItems.length + ' item In cart')}
                        </div>
                    }
                    {/* ----------------------- ORDER MODAL */}

                    {
                        order &&
                        <Modal
                            isOpen={true}
                            ariaHideApp={false}
                            onRequestClose={this.closeModal}>
                            <Zoom>
                                <IconButton aria-label="close"
                                    onClick={this.closeModal}
                                    color="primary" >
                                    <CloseIcon />
                                </IconButton>

                                {/* <Paper style={{ width: 'calc(100vw - 26rem)', margin: '0 auto', padding: '3rem' }} >
                                  */}
                                <div className="order-details">

                                    <div style={{ fontSize: '4rem', color: 'gray' }} >Success</div>



                                    <CheckCircleIcon style={{ fontSize: '14rem', color: 'green', margin: '2rem 0 2.3rem 0' }} />



                                    <div style={{ letterSpacing: '0.6px', color: '#555', fontWeight: 600 }} >Order ID: {" " + order._id}
                                        <br />
                                        More Details on

                                        <Button color="primary"
                                            onClick={() => this.props.history.push('/UserOrdersScreen')}  >
                                            History page
                                        </Button>
                                    </div>


                                    {/* <ul>
                                            <li>
                                                <div>Name</div>
                                                <div>{order.shippingAddress.fullName}</div>
                                            </li>
                                            <li>
                                                <div>Address</div>
                                                <div>{order.shippingAddress.address}</div>
                                            </li>
                                            <li>
                                                <div>eMail</div>
                                                <div>{order.shippingAddress.email}</div>
                                            </li>
                                            <li>
                                                <div>Created At: </div>
                                                <div>{dateFormat(order.createdAt)}</div>
                                            </li>
                                            <li>
                                                <div>Total</div>
                                                <div>{utils.formateCurrency(order.totalPrice)}</div>
                                            </li>
                                            <li>
                                                <div>Cart Items</div>
                                                <div>
                                                    {order.orderItems.map((i) => (
                                                        <div key={i.name} >
                                                            <div>{i.name} {" x "} {i.qty}</div>
                                                            <div>seller: {i.seller}</div>
                                                        </div>

                                                    ))}</div>
                                            </li>
                                        </ul> */}
                                </div>
                                {/* </Paper > */}
                            </Zoom>
                        </Modal>
                    }
                    {/* ----------------------- CART */}
                    {(cartItems?.length || 0) !== 0 && (
                        <div>
                            <div className="cart">
                                <Fade direction='left' duration='100' cascade>
                                    <ul className="cart-items">
                                        {
                                            cartItems.map((item) => (
                                                <li key={item._id}>
                                                    <div><img src={baseImgUrl + item.seller + '/' + item.image} alt={item.title} /></div>
                                                    <div>
                                                        <div>{item.title}</div>
                                                        <div>
                                                            <div>{utils.formateCurrency(item.price)}    <CloseIcon />  {item.count}
                                                                <button
                                                                    className='cart-btn'
                                                                    onClick={() => this.props.Action_removeFromCart(item)}>
                                                                    Remove
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </Fade>
                            </div>
                            {cartItems.length > 0 &&
                                (
                                    <div>
                                        <div className="cart">
                                            <div className="total">

                                                <div>Total {this.cartTotal() + "  "}</div>

                                                <Button variant="outlined" size="large" color="secondary"
                                                    onClick={() => { this.setState({ isShowCheckout: true }) }}   >
                                                    Proceed
                                                </Button>

                                            </div>
                                        </div>

                                        {/* GOOGLE LOGIN */}
                                        {/* {console.log('this.state.isShowCheckout:', this.state.isShowCheckout)} */}
                                        {
                                            (this.state.isShowCheckout && !user?.isAuthenticated) &&
                                            (

                                                <Fade direction='right' duration='100' cascade>
                                                    <div className="login-box">
                                                        <Button
                                                            variant="outlined"
                                                            size="large"
                                                            fullWidth

                                                            startIcon={<VpnKeyIcon />}
                                                            onClick={() => this.props.Action_LoginsOpener(true)}
                                                        >
                                                            Login
                                                        </Button>
                                                    </div>
                                                </Fade>
                                            )
                                        }

                                        {/* USE POSTAL DATA */}
                                        {
                                            user?.isAuthenticated &&
                                            (<Fade direction='right' duration='100' cascade>

                                                <div className="cart">

                                                    <form onSubmit={this.createOrder}
                                                        className='form-container' >
                                                        <ul>
                                                            <li>
                                                                <label>eMail</label>
                                                                <input type="email"
                                                                    onChange={this.handleInput}
                                                                    required
                                                                    value={user.email}
                                                                    name="cartEmail" />
                                                            </li>
                                                            <li>
                                                                <label>Postal Name</label>
                                                                <input type="text"
                                                                    onChange={this.handleInput}
                                                                    required
                                                                    value={user.name}
                                                                    name="cartName" />
                                                            </li>
                                                            <li>
                                                                <label>Postal Address</label>
                                                                <input type="text"
                                                                    onChange={this.handleInput}
                                                                    required
                                                                    name="cartAddress" />
                                                            </li>
                                                            <li>
                                                                <Button variant="outlined" size="large" color="secondary" type="submit"
                                                                    className='button primary test-submit' style={{ color: '#fff' }}>
                                                                    Checkout
                                                                </Button>
                                                            </li>
                                                        </ul>
                                                    </form>
                                                </div>
                                            </Fade>
                                            )
                                        }
                                    </div>
                                )}
                        </div>
                    )}
                </Paper>
            </span>

        )
    }
}
Cart.propTypes = {
    cartItems: PropTypes.array,
    Action_removeFromCart: PropTypes.func.isRequired,
    Action_createOrder: PropTypes.func.isRequired,
    Action_order_clear: PropTypes.func.isRequired,
    Action_LoginsOpener: PropTypes.func.isRequired,
    order: PropTypes.object,
    loading: PropTypes.bool,
    error: PropTypes.string,
    user: PropTypes.object,
    history: PropTypes.object,
}

export default connect((state) => ({
    cartItems: state.reducer_cart.cartItems,
    order: state.reducer_order.order,
    loading: state.reducer_order.loading,
    error: state.reducer_order.error,
    user: state.reducer_user.user
}),
    {
        Action_removeFromCart,
        Action_createOrder,
        Action_order_clear,
        Action_LoginsOpener,
    }
)(Cart)